import React from "react";
import styled from "styled-components";
import { colors, font } from "@literati/public-ui-shared-react";

export interface MembershipFall25OfferBadgeProps {
  className?: string;
  text?: string;
  backgroundColor?: string;
  textColor?: string;
  iconColor?: string;
}

const Badge = styled.span<{ $backgroundColor: string }>`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.625rem;
  border-radius: 4px;
  background: ${({ $backgroundColor }) => $backgroundColor};
`;

const BadgeText = styled.span<{ $textColor: string }>`
  color: ${({ $textColor }) => $textColor};
  font-family: ${font.fontFamily.avenir};
  font-size: 0.75rem;
  font-weight: 900;
  letter-spacing: 2px;
  text-transform: uppercase;
`;

export const MembershipFall25OfferBadge = ({
  className = "",
  text = "save 59%",
  backgroundColor = colors.periwinkleShade1,
  textColor = colors.white,
  iconColor = colors.white,
}: MembershipFall25OfferBadgeProps) => {
  return (
    <Badge className={className} $backgroundColor={backgroundColor}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="12"
        viewBox="0 0 17 12"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M5.15134 10.3026L4.04693 6.25573L0 5.15133L4.04693 4.04324L5.15134 6.10352e-05L6.25576 4.04324L10.3027 5.15133L6.25576 6.25573L5.15134 10.3026Z"
          fill={iconColor}
        ></path>
        <path
          d="M14.8795 10.2027L14.3903 12L13.8975 10.2027L12.1001 9.71324L13.8975 9.22042L14.3903 7.42303L14.8795 9.22042L16.6769 9.71324L14.8795 10.2027Z"
          fill={iconColor}
        ></path>
        <path
          d="M12.3817 3.24315L12.0928 2.1871L11.0327 1.89785L12.0928 1.60889L12.3817 0.548858L12.6707 1.60889L13.7307 1.89785L12.6707 2.1871L12.3817 3.24315Z"
          fill={iconColor}
        ></path>
      </svg>
      <BadgeText $textColor={textColor}>{text}</BadgeText>
    </Badge>
  );
};

export default MembershipFall25OfferBadge;
